import ProductCard from "@components/BasicComponents/Cards/ProductCard/ProductCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CompanyProductSlider.module.scss"
import MiddleArcSvg from "./MiddleArcSvg"

type Props = {
	data: AdvancedSideAssetModuleType
}

const CompanyProductSlider = (props: Props) => {
	const mainContent = props.data.mainContent

	return (
		<section>
			<ContainerWrapper
				className={"productSlider"}
				style={{overflow: "hidden"}}
			>
				<Separator />
				<div className={styles.cardsBox}>
					{/* <Separator  /> */}
					{mainContent?.map(
						(
							element: AdvancedSideAssetMainContent,
							index: number,
						) => {
							return (
								<ProductCard
									containerClassName={styles.card}
									data={element}
									key={`product-${index}`}
									containterWrapperClassName={
										index % 2 === 1
											? styles.containterWrapperClassName
											: ""
									}
									containerTopWrapperClassName={
										index % 2 === 1
											? styles.containerTopWrapperClassName
											: ""
									}
								/>
							)
						},
					)}
					<MiddleArcSvg className={styles.middleSvg} />
				</div>
				{/* <Separator size={128} />
				<div className={styles.cardsBox}>
					{mainContent?.[0] && (
						<ProductCard
							containerClassName={styles.card}
							data={mainContent?.[0]}
						/>
					)}
				</div>
				<Separator size={128} /> */}
			</ContainerWrapper>
		</section>
	)
}

export default CompanyProductSlider
